@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../settings-page.module.less';

.container {
  display: grid;
  grid-template-columns: 3fr 1.5fr 1.5fr 2fr auto;
  border-top: @settings-page--table--border;
  border-left: @settings-page--table--border;
  border-right: @settings-page--table--border;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;

  .loading {
    grid-column: 1 / -1;
    height: 200px;
    background-color: @settings-page--table--body--cell--background-color;
    border-left: @settings-page--table--border;
    border-right: @settings-page--table--border;
    border-bottom: @settings-page--table--border;
  }
}

.container-loading {
  border-left: none;
  border-right: none;

  :first-child.header {
    border-left: @settings-page--table--border;
  }
  .last {
    border-right: @settings-page--table--border;
  }
}

.header {
  background-color: @settings-page--table--header--cell--background-color;
  color: @settings-page--table--header--cell--text-color;
  border-bottom: @settings-page--table--border;
  padding: @settings-page--table--cell--padding;
  white-space: nowrap;
  font-weight: @settings-page--table--header--cell--font-weight;
}

.cell {
  background-color: @settings-page--table--body--cell--background-color;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-bottom: @settings-page--table--border;
  padding: @settings-page--table--cell--padding;
}

.align-center {
  display: flex;
  justify-content: center;
}
